import OnboardingProgressBar from './OnboardingProgressBar';

export default OnboardingProgressBar;
